import { BehaviorSubject } from 'rxjs';

export const ResizeMatrixSubject = new BehaviorSubject({
  viewportWidth: undefined,
  viewportHeight: undefined,
  totalWidth: undefined,
  totalHeight: undefined,
});

export const ScrollMatrixSubject = new BehaviorSubject({
  scrollTop: 0,
  scrollLeft: 0,
});
